export const SECURITY_BACKEND_URL = 'https://works.fleetstudio.com:8443';
export const GOOGLE_CLIENTID =
  '118019305447-va7hqokmp435i7e0nbc6k8p8olkj3l68.apps.googleusercontent.com';
export const GITHUB_CLIENTID = 'Iv23liu63XQXO8bEQjfJ';
export const REDIRECT_URI = 'https://reports.fleetstudio.com';

// export const REDIRECT_URI = 'http://localhost:3001';
